import React from 'react';
import { AlertTriangle } from 'lucide-react';
import AdminLayout from '../../../components/admin/AdminLayout';

export const UnconfiguredNote = ({ children }) => (
  <div className="flex gap-3 rounded-xl border border-amber-500/30 bg-amber-500/10 p-4 text-sm text-amber-200" data-testid="module-unconfigured-note">
    <AlertTriangle className="w-5 h-5 shrink-0 text-amber-400" />
    <div>
      <p className="font-semibold text-amber-300">Módulo básico · Sin configurar</p>
      <p className="text-amber-200/80 mt-0.5">{children}</p>
    </div>
  </div>
);

export const ModuleShell = ({ title, description, note, children, testid }) => (
  <AdminLayout>
    <div className="space-y-6 max-w-5xl" data-testid={testid}>
      <div>
        <h1 className="text-2xl font-bold text-white">{title}</h1>
        <p className="text-gray-400 mt-1 text-sm">{description}</p>
      </div>
      <UnconfiguredNote>{note}</UnconfiguredNote>
      {children}
    </div>
  </AdminLayout>
);
